<template>
  <div class="service-agreement-page agreement-box">
    <div class="mb">欢迎阁下使用货拉拉开放平台！</div>
    <div class="font-small">本协议由同意并承诺遵守本协议规定使用开放平台服务的法律实体（下称“阁下”）、与深圳依时货拉拉科技有限公司、深圳货拉拉科技有限公司（以下深圳依时货拉拉科技有限公司和深圳货拉拉科技有限公司合称“货拉拉”）共同订立。</div>
    <h5>1.提示条款</h5>
      <p>1.1 在接受本协议并开始使用货拉拉开放平台服务之前，请阁下仔细完整地阅读本协议的全部内容，特别是以粗体下划线标注的内容，包括但不限于免除或者限制货拉拉责任的条款、对阁下权利进行限制的条款、争议解决和法律适用条款等。如果阁下对本协议的条款有疑问，请阁下咨询相关法律等专业人士以便充分理解本协议。如果阁下不同意本协议的任一内容，或者无法准确理解条款内容或货拉拉对条款的解释，请不要进行任何后续操作。</p>
      <p>1.2 阁下通过网络页面点击同意、实际使用货拉拉开放平台服务或者以其他方式接受本协议的，即表示阁下自愿接受本协议所述的全部条款和条件，同意受本协议全部内容的约束。</p>
    <h5>2.协议内容和生效</h5>
      <p>2.1 本协议内容包括协议正文、附件及所有货拉拉已经发布的或将来可能发布的各类管理规则、服务使用规则、通知、公告等（合称“规则”）。所有附件及规则为本协议不可分割的一部分，与协议正文具有相同法律效力。</p>
      <p class="underline">2.2 货拉拉有权根据开放平台的发展需要，不时地变更（包括但不限于制定、修订、废止）本协议正文、附件和/或各类规则，并在开放平台网站公示，而不再单独通知阁下。变更后的协议或规则一经公布即自动生效，成为本协议的一部分。如阁下不同意相关变更，应当立即停止使用货拉拉开放平台服务；如阁下继续使用货拉拉开放平台服务的，则视为阁下对变更后的协议和规则不持异议并同意遵守。阁下有义务不时关注并阅读最新版的协议及货拉拉开放平台的各类公告。</p>
      <p class="underline">2.3 阁下通过网络页面点击确认或以其他方式选择接受本协议或实际已使用本协议服务，即表示阁下与货拉拉已达成协议并同意接受本协议的全部约定内容。</p>
    <h5>3.定义</h5>
      <p>3.1 货拉拉开放平台：指货拉拉网站（www.huolala.cn或货拉拉指定的其他网址，下同）上，用于帮助阁下开发应用的平台，域名为open.huolala.cn或货拉拉不时启用的其他域名。货拉拉在开放平台中为阁下提供一些软件和支持材料，阁下通过这些软件和支持材料开发应用。阁下可以通过开放平台技术接口检索由货拉拉提供的或用户授权的与用户相关的数据和/或来自其他货拉拉应用程序的数据信息，或者由阁下应用向货拉拉提供数据。开放平台可能包括但不限于一个或多个API、编程工具和文档。</p>
      <p>3.2 阁下：是指通过有效申请并通过验证的可以基于开放平台进行应用开发的单位或者个人。</p>
      <p>3.3 阁下账号：是指货拉拉为通过有效申请并通过验证的阁下分配的用户账号，该账号可能为阁下注册时使用的手机号。</p>
      <p>3.4 应用：是指阁下基于开放平台所开发的软件或服务，包括自用型应用和他用型应用两种类型。</p>
      <p>3.5 应用程序编程接口：英文名称为Application Programming Interface，可简称为API，是指一些预先定义的函数，目的是提供应用程序与阁下基于某软件或硬件的以访问一组例程的能力，而又无需访问源码，或理解内部工作机制的细节。</p>
      <p>3.6 App key & App secret：指阁下在申请开发新应用时获得的由货拉拉授予的应用程序接入账户和密钥。App key是应用的唯一标识，货拉拉通过App key来鉴别应用发布者的身份。App secret是货拉拉给应用分配的密钥，该密钥在一定技术条件下可保证应用来源的可靠性。</p>
      <p>3.7 货拉拉用户：可简称为“用户”，指所有直接或间接使用阁下基于货拉拉开放平台开发的应用的货拉拉平台用户（包括单位和个人），以及浏览阁下应用相关信息的网络访客。</p>
    <h5>4.货拉拉服务内容</h5>
      <p>4.1 货拉拉为阁下提供应用开发的相关网络环境和技术支持。</p>
      <p>4.2 阁下在开放平台申请并成功成为阁下，在申请发布一个新应用时，开放平台将为阁下授予一个针对该应用的唯一的App key 和App secret ，以便于阁下对应用的管理和维护。</p>
    <h5>5.阁下注册</h5>
      <p>5.1 阁下应当符合开放平台的准入条件，按照注册流程注册阁下账户成为阁下。</p>
      <p>5.2 阁下理解并认可，货拉拉仅能以普通或非专业人员的知识水平标准对阁下在注册环节填写或提交的注册信息及注册资料进行表面识别，并且货拉拉保留抽查、要求阁下补充提交、及时更新前述信息或资料的权利。阁下应当对注册信息及注册材料的真实性、合法性、持续有效性独立承担全部责任；如货拉拉发现阁下的注册信息或资料造假或失效的，货拉拉有权对阁下的阁下账户采取限制措施或者终止本协议、停止提供服务，并根据相关规则对阁下进行处理。</p>
    <h5>6.货拉拉权利义务</h5>
      <p>6.1 货拉拉根据其能力和意愿为阁下提供一定的应用开发的相关网络环境和技术支持，包括应用数据接口的开发、封装，数据同步，应用开发、运行的系统环境，以及与此有关的互联网技术服务，为阁下和用户之间进行应用许可相关事宜提供平台和便利。</p>
      <p>6.2 货拉拉有权管理货拉拉开放平台，对阁下和用户的注册数据及交易行为进行查阅，发现注册数据或交易行为中存在任何异常或疑问，均有权向阁下发出询问或要求改正的通知，或者直接作出删除等处理。 如发现或认为存在下列情况的，货拉拉以普通或非专业人员的知识水平标准对相关内容进行判别，可以认为这些内容或行为具有违法或不当性质的，货拉拉有权删除相关信息或停止向阁下提供服务，或采取其他限制性措施，并有权追究相关法律责任：</p>
        <dt>6.2.1 货拉拉发现阁下可能存在诈骗、盗窃、传播计算机病毒、侵犯用户隐私等违法或不当行为的；</dt>
        <dt>6.2.2 行政执法机关或司法机关就阁下在平台上的行为进行调查，或作出相关决定或裁决的；</dt>
        <dt>6.2.3 货拉拉从任何第三方获知阁下有侵犯他人合法权益、违反公序良俗等违法或不当行为，或者具体应用存在此类重大问题的。</dt>
      <p class="underline">6.3 阁下同意，货拉拉根据其判断认为阁下账户存在异常活动，或者阁下违反本协议约定的，有权单方限制该等账户的权限或功能，单方暂停或终止阁下使用相关服务和账户。</p>
      <p>6.4 阁下同意，其因注册账户、使用开放平台、行使或履行本协议的权利义务而产生的或向货拉拉提交的任何信息/数据，无论本协议终止前还是终止之后，货拉拉均有权合理使用，使用方式包括但不限于依据该等信息/数据进行技术分析、市场调研；同时，对于该等信息/数据，无论本协议是否终止，货拉拉均无义务返还阁下。货拉拉无义务就获取、备份、处理、使用前述信息/数据而向阁下支付任何费用。</p>
      <p>6.5 阁下了解并同意，货拉拉有义务根据有关法律要求向司法机关或政府部门提供阁下的信息和资料。在阁下未能按照本协议、开放平台相关规则或者与用户之间的约定履行自己应尽的义务时，货拉拉有权根据自己的判断、有关协议和规则、生效裁判文书或者与交易有关的用户的合理请求披露阁下的信息/资料，货拉拉对此不承担任何责任。</p>
    <h5>7.开放平台使用规则</h5>
      <p>7.1 阁下成功注册阁下账户后，货拉拉将根据阁下的阁下账号和密码确认阁下的身份，该账户仅限于阁下自身使用，阁下不得将该账户以任何形式向任何第三方转让、出租、出借、泄露、披露等。</p>
      <p>7.2 阁下应妥善保管账户和密码，并对以阁下名义使用该账户和密码所进行的一切行为承担全部责任。阁下承诺在密码或账户遭到未获授权的使用，或者发生其他安全问题时，将立即通知货拉拉，阁下同意并确认，除非因货拉拉过错导致账户被盗，货拉拉不对上述情形产生的任何直接或间接的遗失或损害承担责任。</p>
      <p>7.3 阁下声明并保证其使用开放平台服务过程中遵守如下要求：</p>
        <dt>7.3.1 不复制、模仿、修改、篡改、翻译、改编、出借、出售、转许可、在信息网络上传播或转让开放平台服务和/或相关软件，也不得逆向工程、反汇编、反编译、分解拆卸或试图以其他方式发现开放平台服务/软件的源代码，或者在未经明确允许的情况下创作衍生作品；</dt>
        <dt>7.3.2 不分发、销售、转销、租赁、许可、再许可或通过其他方式将开放平台或任何用户信息提供给第三方（包括以任何方式存储开放平台或用户信息致使第三方能够访问）；</dt>
        <dt>7.3.3 不从事避开或修改货拉拉数据统计工具的行为；</dt>
        <dt>7.3.4 不发送和储存带有病毒的、蠕虫的、木马和其他有害的计算机代码、文件、脚本和程序；</dt>
        <dt>7.3.5 不利用货拉拉提供的资源和服务上传、下载、储存、发布任何违法违规、侵权、淫秽、色情、不道德、欺诈、诽谤（包括商业诽谤）、非法恐吓或非法骚扰等信息或内容，不为他人发布该等信息提供任何便利（包括但不限于设置URL、BANNER链接等）；</dt>
        <dt>7.3.6 不侵犯货拉拉、货拉拉的关联方或任何第三方的合法权益；</dt>
        <dt>7.3.7 如开放平台服务涉及第三方软件之许可使用的，同意遵守相关的许可协议的约束；</dt>
        <dt>7.3.8 不从事其他违法、违规或不恰当的行为。</dt>
      <p>7.4 阁下声明并保证其在开放平台开发、发布的应用符合如下要求：</p>
        <dt>7.4.1 真实、合法、准确、完整，不会有任何淫秽、色情、不道德、欺诈、诽谤（包括商业诽谤）、非法恐吓或非法骚扰的内容；</dt>
        <dt>7.4.2 不会侵犯任何第三方享有的合法权利或权益，包括但不限于第三方知识产权等；</dt>
        <dt>7.4.3 不会违反任何法律、法规、条例或规章 (包括但不限于关于规范互联网站、互联网信息、不正当竞争的法律、法规、条例或规章)；</dt>
    <dt>7.4.4 不会直接或间接与下述各项内容链接：（1）任何法律、法规、条例或规章所禁止的商品或服务；或 （2）无权链接或包含的商品或服务。</dt>
      <p>7.5 阁下开发、发布的应用需要收集或使用用户数据（包括但不限于货拉拉平台用户或其他阁下的数据或个人信息，下同）的，应当符合以下要求：</p>
        <dt>7.5.1 阁下必须确保通过合法渠道获取、使用或保存用户数据，并应事先获得用户的同意，且应当告知用户相关数据收集的目的、范围及使用方式，保障用户知情权；</dt>
    <dt>7.5.2 阁下不得请求、收集、索取或以其他方式从任何用户那里获取对货拉拉平台/开放平台的账户、密码或其他身份验证凭据的访问权，不得为任何用户自动登录到货拉拉网站/开放平台网站提供代理身份验证凭据，不得提供“跟踪”功能，包括但不限于识别其他用户在阁下应用档案文件页上查看或操作；</dt>
    <dt>7.5.3阁下不会将通过开放平台技术接口、公开渠道以及基于本协议项下合作获取的相关数据（包括但不限于任何用户信息、用户交易信息、用户针对阁下产品的使用数据等）用于本协议之外的商业目的（包括但不限于单独开发应用，单独销售，与其他任何第三方进行合作）；不会非法获取货拉拉用户信息及用户交易信息用于交易或获取不当利益；不会利用其他开发者的App key或相关权限获取用户数据；</dt>
        <dt>7.5.4 阁下应当仅获取为应用程序运行及功能实现目的而必要的数据，阁下在特定应用中收集的用户数据仅可以在该特定应用中使用，不得将收集的用户数据转移或使用在该特定应用之外, 不得将用户数据出售、转让或用于特定应用之外的任何其他目的；</dt>
        <dt>7.5.5货拉拉有权限制或阻止阁下获取用户数据及开放平台运营数据，有权自主决定相关数据的保存期限，如货拉拉认为阁下使用用户数据的方式、数据收集的目的或收集的范围有可能损害用户体验、侵犯用户权益或者不符合应用程序运行或功能实现的目的，货拉拉有权要求阁下立即删除相关数据并不得再以该方式使用或再行收集该等数据；</dt>
        <dt>7.5.6一旦用户退订或停止使用阁下的应用，阁下必须立即删除从该用户处获取的全部数据，且货拉拉有权基于数据安全的考虑不经通知径行做出删除数据的处理措施。</dt>
      <p>7.6 阁下同意开放平台运营数据（包括但不限于用户注册信息、用户针对阁下应用的使用数据）的全部权利均归属货拉拉。阁下承诺在未经货拉拉事先书面批准的情况下，不得为任何目的擅自保存、披露、使用或授权他人使用前述运营数据。如经货拉拉书面同意阁下可以使用平台运营数据的，其行为应当同时符合本协议第7.5条的约定。</p>
      <p>7.7 阁下违反法律法规或本协议的约定非法获取或不当使用相关数据的，货拉拉有权采取直接终止本协议、删除阁下已获取的相关数据、下架应用等措施，且前述措施可以合并使用；阁下应当以自己的名义独立承担全部责任，并对给货拉拉、用户或任何第三方造成的损失进行赔偿。</p>
      <p>7.8 阁下同意7接收来自货拉拉或其关联公司发出的邮件、信息。</p>
      <p>7.9 阁下一旦在开放平台注册成功，在申请发布一个新应用时，阁下将得到一个针对该应用的唯一的App Key和App Secret。<span class="underline">阁下同意通过开放平台提供的途径合法获取App Key和App Secret。阁下对App Key和App Secret的机密负完全责任。</span>阁下同意任何时候都不使用其他开发者的App Key和App Secret，也不将自身的App Key和App Secret透露给任何第三方。阁下同意在发现或怀疑他人未经授权就使用其App Key和App Secret时立即通知货拉拉。<span class="underline">货拉拉对阁下的App Key和App Secret的所有使用情况，包括但不限于任何未经授权的访问、更改或者删除、破坏、损害、丢失或未能存储均不承担任何责任。</span></p>
      <p>7.10 阁下不得暗示货拉拉加入、赞助或认可阁下的应用，不得以其他任何方式造成他人混淆，引人误以为是货拉拉提供的应用或与货拉拉存在联系。</p>
      <p>7.11 阁下应在应用提交货拉拉测试之前，按货拉拉要求提供完整的产品说明文档及测试环境。阁下应确保提供给货拉拉测试验收的产品新版本或新功能已通过阁下自身测试验收。如前述新版本或新功能在货拉拉测试过程中，在产品的主干流程中出现缺陷，导致产品主要功能无法正常使用的，则货拉拉有权拒绝再次测试或发布该产品的新版本或新功能。</p>
      <p>7.12 阁下负责及时对其产品进行更新、维护和管理。阁下应用版本的发布（含新版本及原有版本中新功能的发布）需遵循货拉拉的发布规则及流程。未经货拉拉同意，阁下不得擅自发布新版本或新功能，不得擅自修改已接入货拉拉开放平台的阁下应用的程序代码和配置文件。</p>
    <h5>8.费用</h5>
      <p>8.1 货拉拉提供的开放平台技术服务暂时不收取费用，但货拉拉保留今后收费的权利，费用标准及结算方式等收费规则将提前至少七（7）日在货拉拉开放平台网站公布。阁下若不同意前述收费规则的，应在货拉拉指定的收费规则生效日以前停止使用开放平台服务并书面通知货拉拉终止本协议。阁下逾期未通知货拉拉或者继续使用开放平台服务的，视为阁下同意前述公布的收费规则。</p>
    <h5>9.应用产品在线交易</h5>
      <p>9.1 阁下明确理解并同意，阁下在应用市场发布应用产品（包括但不限于对应用的描述等）、接受用户订购（包括但不限于向用户收费、退款等）等需严格遵守应用市场相关服务协议及规则的约定，阁下在正式向用户提供应用的使用许可之前，应自行与用户单独签署相应的《软件许可协议》，并严格按照协议的约定履行。货拉拉不对应用的交易情况作出任何承诺、保证或担保。</p>
      <p>9.2 应用的描述：阁下提供的在开放平台上展示的文字描述、图画或照片，可以是a)对阁下合法拥有且阁下希望交易的应用的描述；或b)对用户正在寻找的应用的描述。阁下可以通过开放平台发布任一类应用描述，或两种类型同时发布，条件是阁下必须取得货拉拉的同意。货拉拉不对应用描述的准确性或内容负责。</p>
      <p class="underline">9.3 阁下违反本协议约定、开放平台规则或货拉拉平台相关规则的，货拉拉有权从开放平台删除或屏蔽阁下提供的应用或限制其功能，此时将造成用户无法正常使用阁下应用所提供的服务。该等情况的发生属于阁下过错或过失，相关责任应由阁下独立承担。</p>
      <p>9.4 用户使用阁下提供的应用和收费服务发生的任何纠纷应由用户和阁下自行协商解决，货拉拉不承担任何责任。货拉拉在用户与阁下产生纠纷时将努力进行协调，阁下也应秉承为用户提供优质服务的理念为用户提供便利，但货拉拉并不保证协调取得实际效果。</p>
    <h5>10.知识产权</h5>
      <p>10.1 货拉拉开放平台上由货拉拉或第三方权利人提供的内容，包括但不限于作品、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计等，均由货拉拉或该第三方权利人依法拥有其知识产权（包括但不限于商标权、专利权、著作权、商业秘密等），非经货拉拉或该第三方权利人事先书面同意，阁下不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表。</p>
      <p>10.2 根据本协议的条款和条件，货拉拉授予阁下有限的、非排他性的、可随时终止的和不可再分发的许可，仅限于阁下在自己访问和使用开放平台开发、测试、显示其应用时，允许阁下访问货拉拉提供的或用户自身授权的用户信息，并允许其他货拉拉用户访问阁下应用；但货拉拉有权根据服务需要或保障用户权益的考虑限制、约束或禁止阁下或其他货拉拉用户访问阁下的应用。</p>
      <p>10.4 阁下保留其创建的应用内容以及其中包括的所有权利、权属或权益，包括但不限于归属于阁下的知识产权（货拉拉知识产权除外）。<span class="underline">阁下在开发者服务中或通过开放平台提交申请或发布阁下应用，即表明阁下授予货拉拉服务期内的、非排他性的、完全给付并免费的全球性许可，允许货拉拉使用、复制、再许可、重设格式、修改、删除、添加、公开显示、重现、分发和执行阁下应用，以及将其存储和缓存在货拉拉指定服务器上。</span></p>
    <h5>11.协议终止和转让</h5>
      <p>11.1 本协议在符合以下任意一项情形时，货拉拉有权终止向阁下提供服务：</p>
        <dt>11.1.1 自然终止：阁下与货拉拉或其关联方签署的《货拉拉平台合作协议》或其他协议（如有）因任何原因终止的，本协议将同时终止。</dt>
        <dt>11.1.2 通知解除：货拉拉可提前15天以书面通知的方式解除本协议而无须承担违约责任。</dt>
        <dt>11.1.3 单方解除权：出现下列情况之一的，货拉拉有权立刻终止本协议，且按有关规则对阁下进行处理：</dt>
          <dd>（1） 阁下违反本协议项下的任何约定、承诺或保证；</dd>
          <dd>（2） 阁下违反开放平台的各类规则，而被货拉拉终止提供服务的；前述情况下，如阁下在本协议终止后再一次直接或间接或以他人名义注册并登录货拉拉开放平台的，货拉拉一经发现即有权直接单方终止向该阁下提供服务。</dd>
        <dt>11.1.5 如货拉拉通过阁下提供的信息与阁下联系时，发现阁下在注册时填写的联系方式已失效，导致货拉拉无法与阁下取得联系的，货拉拉有权终止向该阁下提供服务。</dt>
      <p>11.2 协议终止后的处理</p>
        <dt>11.2.1 服务终止后，货拉拉没有义务为阁下保留原账户中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给阁下或用户或第三方，亦不就终止服务而对阁下或用户或任何第三方承担任何责任。</dt>
        <dt>11.2.2 不论货拉拉与阁下之间的服务因任何原因以任何方式终止，货拉拉仍有权：</dt>
          <dd>（1） 保存或不保存该阁下的数据及以前的行为记录；</dd>
          <dd>（2） 对于阁下在服务终止前实施的违法或违约行为所导致的任何赔偿和责任， 阁下必须完全独立地承担，货拉拉有追索权；</dd>
          <dd>（3） 要求阁下立即删除其从开放平台中获得的全部数据，包括但不限于用户数据、开放平台运营数据；且货拉拉有权基于数据安全的考虑不经通知径行做出删除相关数据的处理措施。</dd>
    <h5>12.违约责任</h5>
      <p>12.1 阁下明确理解并同意货拉拉有权以普通或非专业人员的知识水平标准对阁下的违约行为进行单方认定，并根据单方认定结果适用规则予以处理，包括但不限于对阁下的阁下账户采取限制措施、中止/终止向阁下提供服务（包括开放平台API的调用，以下同）、要求阁下赔偿损失等，且无须征得阁下的同意或提前通知阁下。货拉拉根据相关规则对阁下进行处理后，不免除阁下应当承担的法律责任。</p>
      <p>12.2 如因阁下违反有关法律法规或者本协议、相关规则之规定，使货拉拉遭受任何损失、受到用户、任何第三方的索赔或任何行政管理部门的处罚，阁下应对货拉拉、用户或相关第三方的损失进行全额赔偿。</p>
      <p>12.3 阁下应赔偿货拉拉的损失包括但不限于：货拉拉因阁下的违约行为遭受的经济损失、商誉损失及其他直接或间接损失，以及为了防止损失扩大或追究阁下的责任所支出的差旅费、公证费、律师费、诉讼费等全部合理费用。</p>
    <h5>13.责任限制和免责</h5>
      <p class="underline">13.1 对于开发、运营、支持和维护阁下应用，阁下同意独立承担所有的风险和后果。货拉拉没有责任和义务对于发布在货拉拉开放平台上的任何不准确或不正确的内容承担任何责任，无论该等不准确或不正确是由用户所造成的，还是由于应用所使用的或与应用相连接的任何设备或程序所造成的。</p>
      <p class="underline">13.2 本协议的签署并不意味着货拉拉成为用户在货拉拉开放平台上与阁下进行交易的参与者，对前述交易货拉拉仅提供技术服务，不对阁下和用户行为的合法性、有效性及应用的真实性、合法性和有效性作任何明示和默示的担保。</p>
      <p class="underline">13.3 阁下明确理解和同意，货拉拉服务将按“现状”和按“可得到”的状态提供。货拉拉将在现有技术的基础上尽最大努力提供相应的安全措施以保障服务安全和正常运行，但受限于现有技术、客观条件以及可能发生的不可抗力事件，货拉拉在此明确声明对服务不作任何明示或暗示的保证，包括但不限于对服务的可适用性、没有错误或疏漏、持续性、准确性、可靠性、适用于某一特定用途。</p>
      <p class="underline">13.4 货拉拉不对因下述任一情况而导致的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿（无论货拉拉是否已被告知该等损害赔偿的可能性）：</p>
        <dt class="underline">13.4.1 在货拉拉已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全、计算机病毒等因素；</dt>
        <dt class="underline">13.4.2 因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</dt>
        <dt class="underline">13.4.3 因电力供应故障、通讯网络故障等公共服务因素或第三人因素。</dt>
      <p class="underline">13.5 在任何情况下，货拉拉均不对任何间接性、后果性、惩戒性、偶然性、特殊性或刑罚性的损害，包括阁下使用开放平台而遭受的利润损失承担责任（即使货拉拉已被告知该等损失的可能性）。</p>
      <p class="underline">13.6 尽管本协议中可能含有相反的规定，货拉拉对阁下承担的全部责任，始终不超过阁下在已经过的服务期内因使用开放平台而支付给货拉拉的费用（如有）。</p>
    <h5>14.通知和送达</h5>
      <p>14.1 除法律法规另有强制性规定外，本协议签订或履行过程中，货拉拉向阁下传递的书面通知，按照阁下向货拉拉提供的通讯地址交邮后的第三个自然日即视为送达；书面通知的形式还包括但不限于在开放平台公告、向阁下发送电子邮件、开放平台站内信、系统信息、手机短信和传真等电子方式，在采用电子方式进行书面通知的情况下，发送当日即视为送达。</p>
      <p>14.2 阁下对于货拉拉的通知应当通过货拉拉对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p>
    <h5>15.法律适用和争议解决</h5>
      <p>15.1 本协议的订立、履行、解释、变更与争议解决均适用中华人民共和国大陆地区法律（不包括冲突法规则）。</p>
      <p>15.2 如本协议与适用之法律相抵触的，则相应条款将完全按照法律规定重新解释，但其他条款继续有效。</p>
      <p class="underline">15.3 因签订或履行本协议发生的争议，以及与本协议有关之争议，双方因尽力友好协商解决；协商不成的，任一方均可向深圳市福田区人民法院提起诉讼。</p>
  </div>
</template>

<script>
  export default {
    name: 'service'
  }
</script>

<style lang="scss" scoped>
  .service-agreement-page {
    
  }
  .agreement-box {
    border-radius: 4px;
    color: #424456;
    .title {
      font-size: 16px;
      color: #212121;
      margin-bottom: 20px;
      text-align: center;
    }
    .font-small {
      font-size: 12px;
    }
    .underline {
      color: #000;
      text-decoration: underline;
    }
    p {
      text-indent: 15px;
    }
    dt {
      text-indent: 30px;
    }
    dd {
      text-indent: 45px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/agreement/service.vue